import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { selectProduct, selectUser } from 'workspace/selectors'
import PlanTimelineRealization from './PlanTimelineRealization'
import Duration from 'components/Duration'
import Button from 'components/Button'
import DropdownButton from 'components/DropdownButton'
import ButtonGroup from 'components/ButtonGroup'
import Icon from 'components/Icon'
import { selectPermissions } from './selectors'
import { editSchedule, destroySchedule } from 'workspace/actions'

const PlanTableRow = ({
  id, scheduleId, piecesQuantity, realizedQuantity, bookerName, productOperation,
  priority, remarks, calculatedDuration, productName, isEditable, edit, destroy
}) => {
  return (
    <tr>
      <td>{priority}</td>
      <td>{productName}</td>
      <td>{productOperation}</td>
      <td><Duration minutes={+calculatedDuration} /></td>
      <td>{piecesQuantity}</td>
      <td>
        <PlanTimelineRealization
          realizedQuantity={realizedQuantity}
          piecesQuantity={piecesQuantity}
        />
      </td>
      <td>{bookerName}</td>
      <td>{remarks}</td>
      { isEditable && (<td>
        <ButtonGroup tableActions>
          <Button size='small' onClick={e => edit(scheduleId)}><Icon name='pencil' /></Button>
          <DropdownButton
            size='small'
            color='default'
            popperConfig={{ placement: 'bottom-end' }}
            content={({ close }) => (
              <React.Fragment>
                <a href='javascript:' style={{ minWidth: 50 }} onClick={e => destroy(scheduleId)}>
                  <FormattedMessage id='workspace.table.remove' defaultMessage='Remove' />
                </a>
                <a href='javascript:' style={{ minWidth: 50 }} onClick={close}>
                  <FormattedMessage id='workspace.table.cancel' defaultMessage='Cancel' />
                </a>
              </React.Fragment>
            )}
          >
            <Icon name='trash' />
          </DropdownButton>
        </ButtonGroup>
      </td>) }
    </tr>
  )
}

const mapStateToProps = (state, ownProps) => {
  const product = selectProduct(state, ownProps.productId)
  let productName = ''
  if (product) {
    productName = `${product.description} (${product.code})`
  }

  const booker = selectUser(state, ownProps.bookerId)
  let bookerName = ''
  if (booker) {
    bookerName = `${booker.lastName} ${booker.firstName}`
  }

  const isEditable = selectPermissions(state).planning.write

  return {
    productName,
    bookerName,
    isEditable
  }
}

const mapDispatchToProps = ({
  edit: editSchedule,
  destroy: destroySchedule
})

export default connect(mapStateToProps, mapDispatchToProps)(PlanTableRow)
